import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';

const allProjects = [
  { 
    id: 'black-gold-luxury-design',
    title: 'Black & Gold Luxury Design', 
    category: 'Residential', 
    image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80',
    description: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    client: 'Envato Themeforest',
    year: 'October 25, 2021',
    location: 'San Francisco, CA',
    designer: 'Vesta Designs'
  },
  { 
    id: 'casa-luma-light-filled-modern-home',
    title: 'Casa Luma – Light-filled modern home', 
    category: 'Residential', 
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80',
    description: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    client: 'Envato Themeforest',
    year: 'October 25, 2021',
    location: 'Melbourne, VIC',
    designer: 'Vesta Designs'
  },
  { 
    id: 'contemporary-interior-design',
    title: 'Contemporary Interior Design – Design Your Dream Home', 
    category: 'Renovation', 
    image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&q=80',
    description: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    client: 'Private Client',
    year: 'March 15, 2022',
    location: 'Sydney, NSW',
    designer: 'Vesta Designs'
  },
  { 
    id: 'residential-construction-san-francisco',
    title: 'Residential Construction Site in San Francisco, CA', 
    category: 'Residential', 
    image: 'https://images.unsplash.com/photo-1600573472550-8090b5e0745e?w=800&q=80',
    description: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    client: 'Urban Development Corp',
    year: 'June 10, 2022',
    location: 'San Francisco, CA',
    designer: 'Vesta Designs'
  },
  { 
    id: 'wood-furnitures-living-room',
    title: 'Wood Furnitures For Living Room With 25sqr', 
    category: 'Renovation', 
    image: 'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=800&q=80',
    description: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    client: 'Furniture Co.',
    year: 'August 20, 2022',
    location: 'Brisbane, QLD',
    designer: 'Vesta Designs'
  },
  { 
    id: 'simple-traditional-bobs-house',
    title: "Simple & Traditional Bob's House", 
    category: 'Commercial', 
    image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80',
    description: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    client: 'Bob Smith',
    year: 'November 5, 2022',
    location: 'Perth, WA',
    designer: 'Vesta Designs'
  },
  { 
    id: 'private-residence-dmitrov-house',
    title: 'Private Residence Dmitrov house', 
    category: 'Residential', 
    image: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800&q=80',
    description: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    client: 'Dmitrov Family',
    year: 'January 18, 2023',
    location: 'Adelaide, SA',
    designer: 'Vesta Designs'
  },
  { 
    id: 'velvet-room-luxurious-dramatic',
    title: 'The Velvet Room – Luxurious and dramatic', 
    category: 'Commercial', 
    image: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800&q=80',
    description: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    client: 'Corporate Holdings',
    year: 'April 22, 2023',
    location: 'Melbourne, VIC',
    designer: 'Vesta Designs'
  },
  { 
    id: 'greenline-house-eco-friendly',
    title: 'Greenline House – Eco-friendly residential design', 
    category: 'Town Planning', 
    image: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800&q=80',
    description: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    client: 'Green Living Inc',
    year: 'July 30, 2023',
    location: 'Sydney, NSW',
    designer: 'Vesta Designs'
  },
  { 
    id: 'villa-solis-luxury-warmth',
    title: 'Villa Solis – Luxury with warmth and sunlight', 
    category: 'Residential', 
    image: 'https://images.unsplash.com/photo-1600566752355-35792bedcfea?w=800&q=80',
    description: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    client: 'Private Estate',
    year: 'September 12, 2023',
    location: 'Gold Coast, QLD',
    designer: 'Vesta Designs'
  },
  { 
    id: 'haven-hill-peaceful-retreat',
    title: 'Haven Hill – A peaceful suburban retreat', 
    category: 'Renovation', 
    image: 'https://images.unsplash.com/photo-1600607687644-aac4c3eac7f4?w=800&q=80',
    description: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    client: 'Hill Family Trust',
    year: 'December 1, 2023',
    location: 'Canberra, ACT',
    designer: 'Vesta Designs'
  },
  { 
    id: 'project-echo-monochrome-modern',
    title: 'Project Echo – Monochrome, modern vibes', 
    category: 'Town Planning', 
    image: 'https://images.unsplash.com/photo-1600585152220-90363fe7e115?w=800&q=80',
    description: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    client: 'Echo Enterprises',
    year: 'February 28, 2024',
    location: 'Melbourne, VIC',
    designer: 'Vesta Designs'
  },
];

// Export projects for use in detail page
export { allProjects };

const categories = ['All', 'Residential', 'Commercial', 'Town Planning', 'Renovation'];

const Portfolio = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const [visibleCount, setVisibleCount] = useState(9);

  const filteredProjects = activeCategory === 'All' 
    ? allProjects 
    : allProjects.filter(p => p.category === activeCategory);

  const visibleProjects = filteredProjects.slice(0, visibleCount);
  const hasMore = visibleCount < filteredProjects.length;

  const loadMore = () => {
    setVisibleCount(prev => prev + 6);
  };

  return (
    <div className="portfolio-page">
      {/* Hero Section with background image */}
      <section className="portfolio-hero">
        <div 
          className="portfolio-hero-bg"
          style={{ 
            backgroundImage: 'url(https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1920&q=80)' 
          }}
        />
        <div className="portfolio-hero-overlay" />
        <div className="container">
          <motion.div 
            className="portfolio-hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="portfolio-hero-title">Portfolios</h1>
          </motion.div>
        </div>
      </section>

      {/* Category Filters */}
      <section className="portfolio-filters-section">
        <div className="container">
          <motion.div 
            className="portfolio-filters"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            {categories.map((cat) => (
              <button
                key={cat}
                className={`filter-btn ${activeCategory === cat ? 'active' : ''}`}
                onClick={() => {
                  setActiveCategory(cat);
                  setVisibleCount(9);
                }}
              >
                {cat}
              </button>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Portfolio Grid */}
      <section className="portfolio-grid-section">
        <div className="container">
          <motion.div 
            className="portfolio-grid"
            layout
          >
            <AnimatePresence>
              {visibleProjects.map((project, index) => (
                <motion.div 
                  key={project.id}
                  className="portfolio-card"
                  layout
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, scale: 0.9 }}
                  transition={{ duration: 0.5, delay: index * 0.05 }}
                >
                  <Link to={`/portfolio/${project.id}`} className="portfolio-card-link">
                    <div className="portfolio-card-image">
                      <img src={project.image} alt={project.title} />
                      <div className="portfolio-card-overlay"></div>
                    </div>
                    <div className="portfolio-card-content">
                      <span className="portfolio-card-category">{project.category}</span>
                      <h3 className="portfolio-card-title">{project.title}</h3>
                    </div>
                  </Link>
                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>

          {hasMore && (
            <motion.div 
              className="portfolio-load-more"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3 }}
            >
              <button onClick={loadMore} className="btn-load-more">
                Load More
              </button>
            </motion.div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Portfolio;
